const prefix = import.meta.env.VITE_COLLECTION_PREFIX || '';

export const C = {
  stores: `${prefix}stores`,
  staff: `${prefix}staff`,
  shifts: `${prefix}shifts`,
  shift_types: `${prefix}shift_types`,
  positions: `${prefix}positions`,
  shift_patterns: `${prefix}shift_patterns`,
  default_shift_settings: `${prefix}default_shift_settings`,
  absences: `${prefix}absences`,
  events: `${prefix}events`,
  attendance: `${prefix}attendance`,
  duties: `${prefix}duties`,
  staff_rules: `${prefix}staff_rules`,
} as const;
